interface Props {
  fill?: string
  className?: string
}

const RightArrowSvg = ({ fill = '#181716', className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
  >
    <path
      className={className}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8577 0.25L16.75 6.72732L10.8577 13.2131L10.1 12.5252L14.8995 7.24351H0.25V6.22057H14.9061L10.1009 0.937932L10.8577 0.25Z"
      fill={fill}
    />
  </svg>
)

export default RightArrowSvg
